<div class="lcl-quote-notification">
  <div class="lcl-quote-notification-header">
    <h3 class="lcl-quote-notification-header-text">{{ "THANK_YOU" | translate }}</h3>

    <span class="lcl-quote-notification-header-close" (click)="close.emit()">
      <img class="mr-1" src="assets/icons/icon_close_gray_sm.svg" />
      <span>{{ "BUTTON.CLOSE" | translate }}</span>
    </span>
  </div>

  <div class="lcl-quote-notification-body">
    <div class="lcl-quote-notification-body-header">{{ "YOUR_REQUEST_HAS_BEEN_SUBMITTED" | translate }}</div>
    <div class="lcl-quote-notification-body-hint">
      {{ "MANUAL_QUOTE_NOTIFICATION" | translate }}
    </div>
  </div>
</div>
